import partsAvailability from "../assets/images/icon-4-trans.png";
import roadsideAssistance from "../assets/images/icon-5-trans.png";
import periodicMaintenance from "../assets/images/icon-6-trans.png";
import technicalSupport from "../assets/images/icon-7-trans.png";

// You can change images & subtitles anytime; cards will auto-update.
const aftersalesData = [
  {
    id: "support-1",
    imageSrc: partsAvailability,
    subtitle: "Genuine Spare Parts Availability"
  },
  {
    id: "support-2",
    imageSrc: roadsideAssistance,
    subtitle: "24/7 Roadside Assistance"
  },
  {
    id: "support-3",
    imageSrc: periodicMaintenance,
    subtitle: "Periodic Maintenance Packages"
  },
  {
    id: "support-4",
    imageSrc: technicalSupport,
    subtitle: "Technical Support By Experts"
  }
];

export default aftersalesData;
